import * as Sentry from '@sentry/react';
import { env } from '../env';

const SENTRY_ENABLED = env.devMode !== 'true';

export const initSentry = () => {
  if (SENTRY_ENABLED) {
    Sentry.init({
      dsn: 'https://07b5bb0dca9f2435fc64c46720e572bc@o4506009057558528.ingest.sentry.io/4506553067634688',
      // TODO: adjust
      environment: 'local',
      // TODO: decide if you would like to have the report dialog
      beforeSend(event) {
        if (event.exception) {
          Sentry.showReportDialog({ eventId: event.event_id });
        }
        return event;
      },
    });
  }
};
